import React from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { toJS } from 'mobx'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import ArchiveManip from '../archive/manip'
import ArtistEditView from '../artists/manip'
import EnumsEditView from '../enums_settings/manip'
import { Button, Modal } from 'react-bootstrap'

const showModalEntity = (store, modal, title = '') => {
  // used primary for "archive" button and then for some other entities
  const state = Object.assign({}, store)
  const entityname = modal.entityname || (store.router.params.eid ? linkConst.LINK_CONTRACT_ITEMS : store.router.params.entityname)
  const entityid = modal.id || store.router.params.id
  const entity = modal.entityname || linkConst.LINK_ARCHIVE
  state.cv = new store.manipStores[entity](state)
  state.cv.load(entityname, entityid)
  state.cv.onClick = _ => store.modalEntityControl(false)
  state.onReturn2list = _ => store.modalEntityControl(false)
  state.langtab = modal.langtab || null
  state.cv.title = <h4>
    {linkConst.LINKS_LIST[entityname]}{defaultConst.TITLE_DIVIDER}{title}
    <span className='header-id'>#{store.router.params.id}</span>
  </h4>

  const addToLangTAB = (lng, params) => {
    const tempAttr = store.cv.attributes.find(j =>
      j.metadata_type === params.metadata_type &&
      j.language === lng &&
      j.attribute_id === params.attribute_id &&
      j.attribute_name_internal === params.attribute_name_internal
    )
    if (!tempAttr) {
      store.cv.attributes.push(Object.assign({}, params, { language: lng }))
    } else {
      tempAttr.attribute_value = params.attribute_value
    }
  }

  let body
  switch (entity) {
  case linkConst.LINK_ENUMS:
    body = <EnumsEditView store={state} />
    break
  case linkConst.LINK_PERSONS:
    state.cv.hideSubmitOnly = true
    state.cv.saveEntry = (state, record) => {
      store.modalEntityControl(false)
      const data = toJS(record)
      data.name = data.name.filter((i, k) => {
        return !(i.value === undefined || i.value === null || i.value.length <= 0)
      })
      return store.requester
        .call(`/${linkConst.LINK_PERSONS}/${data.id}`, 'put', data)
        .then(result => {
          // remove unused languages
          store.cv.attributes = store.cv.attributes.filter((j, k) => {
            if (j.metadata_type === modal.params.metadata_type &&
              j.attribute_id === modal.params.attribute_id &&
              j.attribute_name_internal === modal.params.attribute_name_internal) {
              return (result.data.name.find(i => i.lang === j.language))
            } else {
              return true
            }
          })
          // add new languages
          result.data.name.map(i => {
            addToLangTAB(
              i.lang,
              Object.assign({}, modal.params, { language: i.lang, attribute_value: i.value })
            )
          })
          return result.data
        })
        .catch(store.onRequesterError)
    }
    body = <ArtistEditView store={state} />
    break
  default:
    body = <ArchiveManip store={state} />
    break
  }

  return (
    <Modal className={'css-template-' + localStorage.getItem(defaultConst.TEMPLATE_SKIN_KEY)}
      backdrop='static' show onHide={() => store.modalEntityControl(false)}>
      <Modal.Header closeButton>
        <h4> {linkConst.LINKS_LIST[entity]} </h4>
      </Modal.Header>
      <Modal.Body>
        {body}
      </Modal.Body>
    </Modal>)
}

const ModalButton = ({ store, modal, title }) => {
  title = title || (store.cv.record.has('title') && store.cv.record.get('title'))
  store.cv.modalIsOpen = modal ? true : null

  return store.router.params && (
    <div style={{ float: 'right', position: 'relative' }}>
      <Button bsStyle='default'
        onClick={() => store.modalEntityControl(true)}>
        <i className='glyphicon glyphicon-folder-open' /> &nbsp;
        {store.__(defaultConst.TITLE_ARCHIVE_BUTTON)}
      </Button>
      {modal && showModalEntity(store, modal, title)}
    </div>
  )
}

ModalButton.propTypes = {
  store: PropTypes.object
}

export default observer(ModalButton)
